import PrescriptionConfig from "@/views/configs/prescription/index.vue";
import PrescriptionFrequencyConfig from "@/views/configs/prescription/frequency.vue";
import PrescriptionPeriodConfig from "@/views/configs/prescription/period.vue";
import PrescriptionHowLongConfig from "@/views/configs/prescription/how_long.vue";
import PrescriptionGuidanceConfig from "@/views/configs/prescription/guidance.vue";

export default [
  {
    path: "receituario",
    name: "Configuração Receituário",
    component: PrescriptionConfig,
    redirect: {
      path: "/configuracoes/receituario/intervalo",
    },
    children: [
      {
        path: "intervalo",
        name: "Receituário intervalo",
        component: PrescriptionFrequencyConfig,
      },
      {
        path: "quando",
        name: "Receituário quando",
        component: PrescriptionPeriodConfig,
      },
      {
        path: "periodo",
        name: "Receituário periodo",
        component: PrescriptionHowLongConfig,
      },
      {
        path: "orientacao",
        name: "Receituário orientacao",
        component: PrescriptionGuidanceConfig,
      },
    ],
  },
];
